export function slugify(s: string): string {
  const result = s
    .toLowerCase()
    .replace(/ß/g, 's') // ß doesn't decompose via NFKD; map to s (Größe → grose)
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '') // strip combining diacritics (ä → a, ö → o, ü → u)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return result === '' ? 'untitled' : result
}

export type ExportFilenameBaseInput =
  | { scope: 'chart'; page: string; kpi: string; chartType: string }
  | { scope: 'page'; page: string; dashboard: string }
  | { scope: 'collection'; name: string }

export function buildExportFilenameBase(input: ExportFilenameBaseInput): string {
  const date = new Date().toISOString().slice(0, 10)
  if (input.scope === 'chart') {
    // chartType included to disambiguate same-day exports of different chart types
    // for the same page+kpi (e.g. ReviewKpis Timeline + Summary).
    return `${slugify(input.page)}-${slugify(input.kpi)}-${slugify(input.chartType)}-${date}`
  }
  if (input.scope === 'page') {
    return `${slugify(input.page)}-${slugify(input.dashboard)}-${date}`
  }
  return `collection-${slugify(input.name)}-${date}`
}
